import React, { useEffect, useState } from "react";
import Label from "../../../../components/Label";
import { Button, Table } from "react-bootstrap";
import { showNotification } from "../../../../util/Utility";
import axios from "axios";
import Icon from "../../../../components/Icon";
import DefaultModal from "../../../../components/DefaultModal/DefaultModal";
import { callApiV2 } from "../../../../util/apiCaller";
import { Checkbox } from "antd";
import Box from "../../../../components/Box";
import ViewTab from "./ViewTab";
import Loader from '../../../../components/Loader'

const formatEntityList = (list) => {
  return list
    ?.filter((item) => item.organisation_id?._id)
    .map((item) => ({
      label: item.name,
      value: item.organisation_id._id,
    }));
};

function MosqueViewerAccess() {
  const [viewers, setViewers] = useState([]);
  const [showAddModal, setShowAddModal] = useState({
    show: false,
    viewerId: null,
  });
  const [showDeleteMosqueModal, setShowDeleteMosqueModal] = useState({
    show: false,
    viewerId: null,
    org: {},
  });
  const [entitiesList, setEntitiesList] = useState([]);
  const [addEntities, setAddEntities] = useState([]);
  const [isLoading, setIsLoading] = useState(false)

  const fetchViewers = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}onboarding/viewers`,
        config
      );

      if (res.status === 200) {
        setViewers(res.data);
      }
    } catch (error) {
      console.log("error: ", error);
      showNotification("error", "error fetching viewers");
    }
  };

  useEffect(() => {
    fetchViewers();

    const fetchEntitiesList = async () => {
      try {
        const inputData = { pageSize: 1000 };
        setIsLoading(true)
        const entList = await callApiV2({
          method: "post",
          endpoint: "entity/entity-list",
          body: inputData,
        });
        const formattedList = formatEntityList(entList?.data?.entityList);
        setEntitiesList(formattedList);
        setIsLoading(false)
      } catch (error) {
        console.log(error);
        setIsLoading(false)
      }
    };

    fetchEntitiesList();
  }, []);

  const handleAddMosque = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}onboarding/viewer/add-mosques?viewerId=${showAddModal.viewerId}`,
        { addedOrgs: addEntities },
        config
      );
      if (res.status === 200) {
        await fetchViewers();
        setShowAddModal({ show: false, viewerId: null });
        showNotification("Mosques added Successfully");
      }
    } catch (error) {
      console.log("error", error);

      showNotification("error", "error adding mosque");
      setShowAddModal({ show: false, viewerId: null });
    }
  };

  const handleCheckboxChange = (value) => {
    if (addEntities.includes(value)) {
      setAddEntities(addEntities.filter((v) => v !== value));
    } else {
      setAddEntities([...addEntities, value]);
    }
  };

  const handleRemoveMosque = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}onboarding/viewer/delete-mosque`,
        {
          viewerId: showDeleteMosqueModal.viewerId,
          org: showDeleteMosqueModal.org,
        },
        config
      );
      if (res.status === 200) {
        await fetchViewers();
        showNotification("success", "Mosque removed");
        setShowDeleteMosqueModal({ show: false, viewerId: null, org: {} });
      }
    } catch (error) {
      console.log(error);
      setShowDeleteMosqueModal({ show: false, viewerId: null, org: {} });
      showNotification("error", error.message || "some error occured");
    }
  };

  return (
    <div>
      <ViewTab />
      <div className="mosque_view_container">
        <Label className="mosque_view_title">Mosque Viewer Access</Label>
        {isLoading?<Loader/>:<Table className=" " id="viewer_access_table">
          <thead>
            <tr style={{borderBottom:'1px solid #ccc'}}>
              <th style={{borderBottom:'1px solid #ccc'}}>S.No.</th>
              <th style={{borderBottom:'1px solid #ccc'}}>Name</th>
              <th style={{borderBottom:'1px solid #ccc'}}>Email</th>
              <th style={{borderBottom:'1px solid #ccc'}}>Associated Mosques</th>
              <th style={{borderBottom:'1px solid #ccc'}}>Actions</th>
            </tr>
          </thead>
          <tbody >
            {viewers?.map((viewer, i) => (
              <tr key={viewer._id}>
                <td
                  style={{
                    padding: "16px",
                    borderBottom:
                      i === viewers.length - 1 ? "none" : "1px solid #ccc",
                  }}
                >
                  {i + 1}.
                </td>
                <td
                  style={{
                    padding: "16px",
                    borderBottom:
                      i === viewers.length - 1 ? "none" : "1px solid #ccc",
                  }}
                >
                  {viewer.contact_name}
                </td>
                <td
                  style={{
                    padding: "16px",
                    borderBottom:
                      i === viewers.length - 1 ? "none" : "1px solid #ccc",
                  }}
                >
                  {viewer.contact_email}
                </td>
                <td
                  style={{
                    padding: "16px",
                    borderBottom:
                      i === viewers.length - 1 ? "none" : "1px solid #ccc",
                  }}
                >
                  <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                    {viewer.viewer_organisations?.map((v) => (
                      <div style={{ marginBottom: "8px" }} key={v._id}>
                        {v.name}
                      </div>
                    ))}
                  </div>
                  <div>
                    <button
                      className="add-another-mosque"
                      onClick={() => {
                        setShowAddModal({ show: true, viewerId: viewer._id });
                        setAddEntities([]);
                      }}
                    >
                      <Icon iconName={"AddIcon"} /> Add another mosque
                    </button>
                  </div>
                </td>
                <td
                  style={{
                    padding: "16px",
                    borderBottom:
                      i === viewers.length - 1 ? "none" : "1px solid #ccc",
                  }}
                >
                  <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                    {viewer.viewer_organisations.length > 1 ? (
                      viewer.viewer_organisations.map((v) => (
                        <div
                          style={{
                            marginBottom: "8px",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                          key={v._id}
                          role="button"
                          onClick={() =>
                            setShowDeleteMosqueModal({
                              show: true,
                              viewerId: viewer._id,
                              org: v,
                            })
                          }
                        >
                          <Icon iconName={"removeIcon"} />
                          Remove
                        </div>
                      ))
                    ) : (
                      <div>...</div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>}

        <DefaultModal
          show={showAddModal.show}
          onHide={() => setShowAddModal({ show: false, viewerId: null })}
          className="add-mosque-modal"
          centered={true}
          showHeader={false}
          size=""
          showFooter={false}
        >
          <div>
            <Icon
              iconName="modalClose"
              iconSize="xs"
              style={{ marginLeft: "auto" }}
              onClick={() => setShowAddModal({ show: false, viewerId: null })}
            />
            <Label
              className="mosque_view_title"
              style={{ display: "flex", justifyContent: "center" }}
            >
              Add another mosque
            </Label>
            <div style={{ maxHeight: "500px", overflow: "scroll" }}>
              {entitiesList?.map((entity) => (
                <div
                  key={entity.value}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    id={`checkbox-${entity.value}`}
                    className="custom-checkbox"
                    style={{ marginBottom: "8px" }}
                    type="checkbox"
                    value={entity.value}
                    checked={addEntities.includes(entity.value)}
                    onChange={() => handleCheckboxChange(entity.value)}
                  />
                  <label
                    htmlFor={`checkbox-${entity.value}`}
                    role="button"
                    style={{ marginBottom: "8px", userSelect: "none" }}
                  >
                    {entity.label}
                  </label>
                </div>
              ))}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "20px",
                marginTop: "40px",
              }}
            >
              <Button
                type="secondary"
                className="prev-bt"
                style={{ height: "50px", width: "150px" }}
                onClick={() => setShowAddModal({ show: false, viewerId: null })}
              >
                Cancel
              </Button>
              <button
                disabled={addEntities.length === 0}
                className={addEntities.length === 0 ? "gray-bt" : "fill-bt"}
                style={{ height: "50px", width: "150px" }}
                onClick={handleAddMosque}
              >
                Add
              </button>
            </div>
          </div>
        </DefaultModal>
        <DefaultModal
          show={showDeleteMosqueModal.show}
          onHide={() =>
            setShowDeleteMosqueModal({ show: false, viewerId: null, org: {} })
          }
          className="add-mosque-modal"
          centered={true}
          showHeader={false}
          size=""
          showFooter={false}
        >
          <div>
            <Icon
              iconName="modalClose"
              iconSize="xs"
              style={{ marginLeft: "auto" }}
              onClick={() =>
                setShowDeleteMosqueModal({
                  show: false,
                  viewerId: null,
                  org: {},
                })
              }
            />
            <div className="text-center">
              <img src="https://ik.imagekit.io/rzlzf40okya/elixir/diseble.svg" />
              <Label
                justifyContent="center"
                fontSize="20px"
                fontWeight={700}
                my="20px"
              >
                Remove Mosque Association?
              </Label>
              <Label variant="text3" my="20px" color="#7E7E7E">
                {`This action will revoke your ability to view “${showDeleteMosqueModal.org?.name}” mosque’s dashboard.`}
              </Label>
              <Box
                className="test"
                display="flex"
                justifyContent="space-between"
              >
                <button
                  type="secondary"
                  className="prev-bt"
                  style={{ height: "50px", width: "150px" }}
                  onClick={() =>
                    setShowDeleteMosqueModal({
                      show: false,
                      viewerId: null,
                      org: {},
                    })
                  }
                >
                  Cancel
                </button>
                <Button
                  minWidth="200px !important"
                  width="200px !important"
                  height="45px !important"
                  mr="20px !important"
                  className="fill-bt"
                  onClick={() => handleRemoveMosque()}
                >
                  Remove Mosque
                </Button>
              </Box>
            </div>
          </div>
        </DefaultModal>
      </div>
    </div>
  );
}

export default MosqueViewerAccess;
